// extracted by mini-css-extract-plugin
module.exports = {"productDimensionsInputs":"style_productDimensionsInputs__yXb5U","dimensionInput":"style_dimensionInput__u9lrI"};